var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewProject(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.157,
    height: 25.157,
    viewBox: "0 0 25.157 25.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(-60.014 -488.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M8.721,66.576H2.462A1.962,1.962,0,0,1,.5,64.614V57.261a.4.4,0,0,1,.8,0v7.353a1.169,1.169,0,0,0,1.167,1.167H8.721a.4.4,0,0,1,0,.8Z",
    transform: "translate(59.764 447.291)",
    fill: "#b9b8b8",
    stroke: "#f788cc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M70.231,57.8v7.21a1.962,1.962,0,0,1-1.962,1.962H62.234a.4.4,0,1,1,0-.8h6.035a1.169,1.169,0,0,0,1.167-1.167V57.8a.4.4,0,1,1,.8,0Z",
    transform: "translate(14.689 446.895)",
    fill: "#b9b8b8",
    stroke: "#f788cc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M59.283.5H66.1a1.962,1.962,0,0,1,1.962,1.962V9.336a.4.4,0,0,1-.8,0V2.462A1.168,1.168,0,0,0,66.1,1.3H59.283a.4.4,0,0,1,0-.8Z",
    transform: "translate(16.857 488.711)",
    fill: "#b9b8b8",
    stroke: "#f788cc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M.5,9.193V2.462A1.962,1.962,0,0,1,2.462.5H9.086a.4.4,0,1,1,0,.8H2.462A1.169,1.169,0,0,0,1.3,2.462V9.193a.4.4,0,1,1-.8,0Z",
    transform: "translate(59.764 488.711)",
    fill: "#b9b8b8",
    stroke: "#f788cc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M53.911,47.445h.4a4.9,4.9,0,1,1-4.9-4.9,4.9,4.9,0,0,1,4.9,4.9h-.8a4.1,4.1,0,1,0-4.1,4.1,4.106,4.106,0,0,0,4.1-4.1Z",
    transform: "translate(23.18 454.093)",
    fill: "#b9b8b8",
    stroke: "#f788cc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M62.279,51.062v4.694a.4.4,0,0,1-.8,0V51.062a.4.4,0,0,1,.8,0",
    transform: "translate(10.711 448.13)",
    fill: "#b9b8b8",
    stroke: "#f788cc",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M53.029,59.516h4.694a.4.4,0,1,1,0,.8H53.029a.4.4,0,0,1,0-.8",
    transform: "translate(17.217 441.625)",
    fill: "#b9b8b8",
    stroke: "#f788cc",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewProject);
export default __webpack_public_path__ + "static/media/icon-new-project.1fe6aac38a4e1d8edfeea4b6326bb979.svg";
export { ForwardRef as ReactComponent };